import React from 'react';
import { Modal, Form, Alert, Row, Col, Select, Checkbox } from 'antd';
import { UsergroupAddOutlined } from '@ant-design/icons';

const { Option } = Select;

export default function AutoImportMappingsModal({
  open,
  importLoading,
  form,
  onImport,
  onCancel,
  isStudio,
  academicYears,
  importAvailableClusters,
  importAvailableStandards,
  setImportSelectedAy,
  setImportSelectedCluster
}) {
  return (
    <Modal
      title={
        <span>
          <UsergroupAddOutlined style={{ color: '#1890ff', marginRight: 8 }} />
          Import Existing Candidates & Staff to Biometric Device Mappings
        </span>
      }
      open={open}
      onOk={onImport}
      onCancel={onCancel}
      confirmLoading={importLoading}
      okText="Import Users to Device Mappings"
      width={620}
      destroyOnClose
    >
      <Alert
        message={isStudio ? "Studio Biometric User Auto-Population" : "Auto-Population of Biometric User Device Mappings"}
        description={
          isStudio
            ? "Import existing candidate profiles from your assigned clusters into biometric device mappings so they appear in attendance views."
            : "Import existing candidate and staff profiles directly into biometric device mappings. Once imported, they will immediately show in the Monthly Matrix View."
        }
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
      />

      <Form
        form={form}
        layout="vertical"
        initialValues={{
          personType: isStudio ? 'CANDIDATE' : 'ALL',
          idStrategy: 'ID_OR_CODE',
          academicYearId: 'all',
          clusterId: 'all',
          standardId: 'all',
          overwriteExisting: true
        }}
      >
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item name="personType" label="User Target Type" rules={[{ required: true }]}>
              <Select disabled={isStudio}>
                {!isStudio && <Option value="ALL">All (Staff & Candidates)</Option>}
                {!isStudio && <Option value="STAFF">Staff Only</Option>}
                <Option value="CANDIDATE">Candidates Only {isStudio ? '(Studio Scope)' : ''}</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="idStrategy" label="Biometric ID Strategy" rules={[{ required: true }]}>
              <Select>
                <Option value="ID_OR_CODE">Use Candidate ID / Staff Code</Option>
                <Option value="SEQUENTIAL">Sequential IDs (1001, 1002...)</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={12}>
          <Col span={8}>
            <Form.Item name="academicYearId" label="Academic Year Filter">
              <Select
                placeholder="Select Academic Year"
              >
                {academicYears.map(ay => (
                  <Option key={ay.academic_year_id} value={String(ay.academic_year_id)}>
                    {ay.academic_year}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="clusterId" label="Cluster Filter">
              <Select
                placeholder={isStudio ? "Select Cluster" : "All Clusters"}
                onChange={(val) => {
                  setImportSelectedCluster(val);
                  form.setFieldsValue({ standardId: 'all' });
                }}
              >
                {!isStudio && <Option value="all">All Clusters</Option>}
                {importAvailableClusters.map(c => (
                  <Option key={c.cluster_id} value={String(c.cluster_id)}>
                    {c.cluster_name} {c.cluster_code ? `(${c.cluster_code})` : ''}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="standardId" label="Standard Filter">
              <Select placeholder="All Standards">
                <Option value="all">All Standards</Option>
                {importAvailableStandards.map(st => (
                  <Option key={st.standard_id} value={String(st.standard_id)}>
                    {st.standard_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item name="overwriteExisting" valuePropName="checked">
          <Checkbox>Overwrite existing biometric mappings for matching users</Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
}
